module.exports = __webpack_public_path__ + "assets/img/title-ddbeb50c.png";